/**
 * Created by sumudu on 12/5/16.
 */
'use strict';
(function () {
    angular
        .module('crewSchedule')
        .component('assignTrainingComponent', {
            templateUrl: 'crew-schedule/components/assign-trainings-component.tpl.html',
            controller: function (crewSchAssignTraningModel, crewSchAssignTraningLogic, $timeout) {
                var vm = this;

                vm.model = {
                    trainings: [],
                    activeIndex: 0
                };

                vm.$onInit = function () {
                    crewSchAssignTraningModel.trainingsForCrew.subscribe(function (trainingsForCrew) {
                        //hack to fix tab not refresh upon data change
                        vm.model.activeIndex = -1;
                        vm.model.trainings = trainingsForCrew;
                        $timeout(function () {
                            vm.model.activeIndex = 0;
                        }, 100);
                    });
                };

                vm.onTraningSelected = function (training) {
                    if (!!training.isAssigned) {
                        crewSchAssignTraningLogic.assignTraining(training);
                    }else{
                        crewSchAssignTraningLogic.unAssignTraining(training);
                    }
                };
            },

            bindings:{
              crewStatus: '<'
            }
        });
})();
